import { Stack, Typography } from "@mui/material";
import CheckIcon from "./CheckIcon";
import CancelIcon from "./CancelIcon";

export default function Regularidad({ condicion }) {
  return (condicion === true ? (
    <Stack
      sx={{
        direction: "column",
        justifyContent: "center",
        alignItems: "center",
        marginY: 2,
        gap: 2,
      }}
    >
      <CheckIcon />
      <Typography variant="h5" fontWeight="bold" color="#393">
        Alumno Regular
      </Typography>
    </Stack>
  ) : (
    <Stack
      sx={{
        direction: "column",
        justifyContent: "center",
        alignItems: "center",
        marginY: 2,
        gap: 2,
      }}
    >
      <CancelIcon />
      <Typography variant="h5" fontWeight="bold" color="#B71234">
        Alumno No Regular
      </Typography>
    </Stack>
  ));
}
